import jMain from './main/Index'
import jSpec1 from './spec1/Index'
import jSpec2 from './spec2/Index'
import jSpec3 from './spec3/Index'
import jPileDriving from './pileDriving/Index'
import jSpec5 from './spec5/Index'
import jSpec6 from './spec6/Index'
import jSpec7 from './spec7/Index'
import jEarth from './earth/Index'
import jSpec9 from './spec9/Index'
import jSpec10 from './spec38/Index'
import jSpec12 from './spec/Index'
import jSpec13 from './spec/Index'
import jSpec14 from './spec/Index'
import jSpec15 from './spec/Index'
import jSpec16 from './spec/Index'
import jSpec17 from './spec/Index'
import jSpec18 from './spec/Index'
import jSpec19 from './spec/Index'
import jSpec20 from './spec/Index'
import jSpec21 from './spec/Index'
import jSpec22 from './spec/Index'
import jSpec23 from './spec/Index'
import jSpec24 from './spec/Index'
import jSpec25 from './spec/Index'
import jSpec26 from './spec/Index'
import jSpec27 from './spec/Index'
import jSpec28 from './spec/Index'
import jSpec29 from './spec/Index'
import jSpec30 from './spec/Index'
import jSpec31 from './spec31/Index'
import jWelding from './welding/Index'
import jSpec4 from './spec4/Index'
import jSpec34 from './spec/Index'
import jSpec35 from './spec35/Index'
import jSpec36 from './spec36/Index'
import jSpec37 from './spec37/Index'
import jSpec38 from './spec38/Index'
import jSpec39 from './spec/Index'
import jSpec40 from './spec/Index'
import jSpec41 from './spec/Index'
import jAuthor from './author/Index'
import jTech from './tech/Index'
import jInput from './input/Index'
import jSpec50 from './spec50/Index'
import jSpec51 from './spec51/Index'
import jSpec52 from './spec52/Index'
import jSpec53 from './spec53/Index'
import jSpec54 from './spec54/Index'
import jSpec55 from './spec55/Index'
import jSpec56 from './spec56/Index'
import jSpec57 from './spec57/Index'
import jSpec58 from './spec58/Index'
import jSpec59 from './spec59/Index'
import jSpec60 from './spec60/Index'
import jSpec61 from './spec61/Index'
import jSpec62 from './spec62/Index'
import jSpec63 from './spec63/Index'
import jSpec64 from './spec64/Index'
import jSpec65 from './spec65/Index'
import jSpec66 from './spec66/Index'

export default {
  jMain,
  jAuthor,
  jTech,
  jInput,
  jSpec1,
  jSpec2,
  jSpec3,
  jPileDriving,
  jSpec5,
  jSpec6,
  jSpec7,
  jEarth,
  jSpec9,
  jSpec10,
  jSpec12,
  jSpec13,
  jSpec14,
  jSpec15,
  jSpec16,
  jSpec17,
  jSpec18,
  jSpec19,
  jSpec20,
  jSpec21,
  jSpec22,
  jSpec23,
  jSpec24,
  jSpec25,
  jSpec26,
  jSpec27,
  jSpec28,
  jSpec29,
  jSpec30,
  jSpec31,
  jWelding,
  jSpec4,
  jSpec34,
  jSpec35,
  jSpec36,
  jSpec37,
  jSpec38,
  jSpec39,
  jSpec40,
  jSpec41,
  jSpec50,
  jSpec51,
  jSpec52,
  jSpec53,
  jSpec54,
  jSpec55,
  jSpec56,
  jSpec57,
  jSpec58,
  jSpec59,
  jSpec60,
  jSpec61,
  jSpec62,
  jSpec63,
  jSpec64,
  jSpec65,
  jSpec66,
}
